import { useTranslation } from 'react-i18next'
import { useIonToast } from '@ionic/react'
import { registerSW } from 'virtual:pwa-register'

import { isNative } from '@/utils/utils'

export const useServiceWorkerUpdateContent = () => {
  const intervalInMs = 1000 * 60 * 1
  const [presentToast] = useIonToast()
  const { t } = useTranslation('common')

  const toast = (callback) =>
    presentToast({
      message: t('common.refresh.title'),
      position: 'top',
      buttons: [
        {
          text: t('common.refresh.action'),
          role: 'cancel',
          handler: callback,
        },
      ],
    })

  const updateSW = registerSW({
    onNeedRefresh() {
      toast(() => {
        updateSW(true)
        window.location.reload()
      })
    },
  })

  const onUpdateFound = async () => {
    if (isNative()) return
    const registration = await navigator.serviceWorker.getRegistration()

    if (registration) {
      setInterval(() => {
        try {
          registration.update()
        } catch (e) {
          console.log('Checking for updates failed... ', e)
        }
      }, intervalInMs)
      registration.onupdatefound = () => {
        console.log('Update found')
        const installingWorker = registration.installing
        if (installingWorker == null) {
          return
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://cra.link/PWA.'
              )

              // Execute callback
              toast(() => updateSW(true))
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.')
            }
          }
        }
      }
    }
  }

  try {
    onUpdateFound()
  } catch (e) {
    console.log('Cannot update service worker', e)
  }
}
